module.exports = __webpack_public_path__ + "fontawesome-webfont.acf3dcb7ff752b5296ca.svg";


//////////////////
// WEBPACK FOOTER
// E:/Office Projects/Paarsel/paarsel_business_web/paarsel_business_web/src/assets/icon/font-awesome/fonts/fontawesome-webfont.svg?v=4.7.0
// module id = ../../../../../src/assets/icon/font-awesome/fonts/fontawesome-webfont.svg?v=4.7.0
// module chunks = styles